<template>
  <div
    class="category-faq-page pb-14 pt-4 px-4 px-sm-6 px-md-6 px-lg-10 px-xl-10 mx-auto"
  >
    <div class="category-faq-page-top d-flex">
      <div class="d-flex align-start">
        <BackToLibraryArrowControl
          class="category-page-back-btn"
          :to="backTo"
        />
      </div>
      <div>
        <CategoryMeta :category-info="categoryInfo" />
        <CategoryNavBar
          :category-info="categoryInfo"
          :books-counter="booksCounter"
        />
      </div>
      <div></div>
    </div>
    <div>
      <v-expansion-panels class="faq-block" flat tile>
        <v-expansion-panel
          v-for="(item, i) in categoryInfo.FAQ"
          :key="i"
          class="faq-item-block"
        >
          <v-expansion-panel-header>
            <div v-html="parseText(item.question)"></div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-html="parseText(item.answer)"></div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import CategoryMeta from '@/components/views/CategoryView/CategoryMeta.vue';
import CategoryNavBar from '@/components/views/CategoryView/CategoryNavBar.vue';
import BackToLibraryArrowControl from '@/components/controls/BackToLibraryArrowControl/BackToLibraryArrowControl.vue';
import AppStateEnum from '@/enums/AppStateEnum';
import ParseAIResponseUtil from '@/services/utils/ParseAIResponseUtil';

export default {
  name: 'CategoryFaqLayout',
  components: {
    CategoryMeta,
    CategoryNavBar,
    BackToLibraryArrowControl
  },
  props: {
    label: String,
    categoryInfo: {
      type: Object,
      default: () => ({})
    },
    booksCounter: {
      type: [Number, String],
      default: 0
    },
    prevRouteLink: Object
  },
  data() {
    const lang = this.$store.getters['ContextStore/currentLanguageGetter'];
    const defaultRoute =
      lang === 'en'
        ? { name: AppStateEnum.MANAGE_PUBLICATION }
        : {
            name: AppStateEnum.MANAGE_PUBLICATION_LANGUAGE,
            params: { pathMatch: lang }
          };
    return {
      defaultRoute
    };
  },
  computed: {
    backTo() {
      return this.prevRouteLink || this.defaultRoute;
    }
  },
  methods: {
    parseText(text) {
      return ParseAIResponseUtil.parseAIResponse(text);
    }
  }
};
</script>

<style lang="less">
@import '~@/assets/styles/base.less';

.category-faq-page {
  @spec-small: ~'(max-width: 700px)';
  @small: ~'(max-width: 767px)';
  @narrow: ~'(min-width: 768px) and (max-width: 1023px)';
  @normal: ~'(min-width: 1024px) and (max-width: 1279px)';

  max-width: var(--app-max-width);
  margin: 0 auto;
  min-height: var(--footer-spacer-wide);

  @media @normal, @narrow, @small {
    min-height: var(--footer-spacer-narrow);
  }

  @media @spec-small {
    min-height: var(--footer-spacer-small);
  }

  .category-faq-page-top {
    display: flex;
    margin-bottom: 8px;
    position: relative;

    @media @normal, @wide {
      margin-bottom: 16px;
      justify-content: space-between;

      > div {
        flex: 1 1 0;
      }
    }

    &:has(.category-nav-bar) {
      border-bottom: 1px solid #e2e8f0;
    }

    > div {
      &:first-child {
        @media @small, @narrow-alt {
          position: absolute;
          z-index: 1;
        }
      }
      &:last-child {
        @media @small, @narrow-alt {
          display: none;
        }
      }
    }
  }

  .category-page-back-btn {
    max-width: 48px;
    max-height: 48px;
    min-width: 0 !important;
    padding: 0 !important;
  }

  .faq-block {
    @media @normal, @wide {
      max-width: 620px;
      margin: 0 auto;
    }
  }

  .faq-item-block {
    &:not(:last-child) {
      border-bottom: 1px solid #e2e8f0;
    }

    &.v-expansion-panel--active:not(:first-child),
    &.v-expansion-panel--active + .v-expansion-panel {
      margin-top: 0;
    }

    .v-expansion-panel--active {
      > .v-expansion-panel-header {
        min-height: 0;
        padding-left: 0;
        padding-right: 0;
      }
    }

    > .v-expansion-panel-header,
    .v-expansion-panel-content__wrap {
      min-height: 0;
      padding-left: 0;
      padding-right: 0;
    }

    > .v-expansion-panel-header {
      font-weight: 700;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: -0.03em;
    }
  }
}
</style>
